/**
 * DATE CELL
 * Cellule pour afficher une date formatée
 */

type DateFormat = 'short' | 'long' | 'datetime' | 'time';

interface DateCellProps {
  date: string | Date | null | undefined;
  format?: DateFormat;
  emptyMessage?: string;
  className?: string;
}

export function DateCell({ date, format = 'short', emptyMessage = '-', className }: DateCellProps) {
  if (!date) {
    return <span className={`text-sm text-zinc-500 ${className || ''}`}>{emptyMessage}</span>;
  }

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    let formatted: string;

    switch (format) {
      case 'short':
        // 15/03/2024
        formatted = dateObj.toLocaleDateString('fr-FR');
        break;
      case 'long':
        // 15 mars 2024
        formatted = dateObj.toLocaleDateString('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        break;
      case 'datetime':
        // 15/03/2024 14:30
        formatted = `${dateObj.toLocaleDateString('fr-FR')} ${dateObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
        break;
      case 'time':
        // 14:30
        formatted = dateObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
        break;
      default:
        formatted = dateObj.toLocaleDateString('fr-FR');
    }

    return <span className={`text-sm ${className || ''}`}>{formatted}</span>;
  } catch (error) {
    console.error('Error formatting date:', error);
    return <span className={`text-sm text-zinc-500 ${className || ''}`}>{emptyMessage}</span>;
  }
}
